export const COMPANY_SIZES = [
  { value: '1', label: 'Just me' },
  { value: '2-10', label: '2-10 employees' },
  { value: '11-50', label: '11-50 employees' },
  { value: '51-200', label: '51-200 employees' },
  { value: '201-500', label: '201-500 employees' },
  { value: '500+', label: '500+ employees' }
];

export const INDUSTRIES = [
  { value: 'technology', label: 'Technology' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'finance', label: 'Finance' },
  { value: 'education', label: 'Education' },
  { value: 'retail', label: 'Retail' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'other', label: 'Other' }
];

export const USER_ROLES = [
  { value: 'founder', label: 'Founder / CEO' },
  { value: 'engineering', label: 'Engineering' },
  { value: 'product', label: 'Product' },
  { value: 'design', label: 'Design' },
  { value: 'customer_support', label: 'Customer Support' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'sales', label: 'Sales' },
  { value: 'other', label: 'Other' }
];

export const USE_CASES = [
  { value: 'customer_support', label: 'Customer support ticket management' },
  { value: 'bug_tracking', label: 'Bug tracking and issue management' },
  { value: 'feature_requests', label: 'Feature request management' },
  { value: 'community_management', label: 'Community management' },
  { value: 'team_collaboration', label: 'Team collaboration' },
  { value: 'other', label: 'Other' }
];

export const HOW_DID_YOU_HEAR = [
  { value: 'search', label: 'Search engine' },
  { value: 'social_media', label: 'Social media' },
  { value: 'referral', label: 'Referral from a friend' },
  { value: 'blog', label: 'Blog or article' },
  { value: 'advertisement', label: 'Advertisement' },
  { value: 'other', label: 'Other' }
];
